import { Box, SvgIcon, SvgIconProps } from "@mui/material";

interface IconProps extends SvgIconProps {}

const ValidateIcon = ({ hovered = false, ...props }): IconProps => {
  return (
    <SvgIcon style={{ fill: "none" }} {...props}>
      {
        hovered ? <>
        <path d="M17 1H3C1.89543 1 1 1.89543 1 3V17C1 18.1046 1.89543 19 3 19H17C18.1046 19 19 18.1046 19 17V3C19 1.89543 18.1046 1 17 1Z" fill="#CFFFD0" fill-opacity="0.8"/>
<path d="M17 1H3C1.89543 1 1 1.89543 1 3V17C1 18.1046 1.89543 19 3 19H17C18.1046 19 19 18.1046 19 17V3C19 1.89543 18.1046 1 17 1Z" stroke="#1976D2" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14.4998 6.99988L8.65601 13.3749L5.99976 10.4772" stroke="#1976D2" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
        </> : <>
        <path d="M17 1H3C1.89543 1 1 1.89543 1 3V17C1 18.1046 1.89543 19 3 19H17C18.1046 19 19 18.1046 19 17V3C19 1.89543 18.1046 1 17 1Z" fill="#BFE3C0"/>
<path d="M17 1H3C1.89543 1 1 1.89543 1 3V17C1 18.1046 1.89543 19 3 19H17C18.1046 19 19 18.1046 19 17V3C19 1.89543 18.1046 1 17 1Z" stroke="#292929" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
<path d="M14.4998 6.99988L8.65601 13.3749L5.99976 10.4772" stroke="#292929" stroke-width="1.2" stroke-linecap="round" stroke-linejoin="round"/>
        </>
      }
    {/* <svg width="20" height="20" viewBox="0 0 20 20" fill="none" xmlns="http://www.w3.org/2000/svg"> */}

{/* </svg> */}

    </SvgIcon>
  );
};

export default ValidateIcon;
